export default __webpack_public_path__ + "static/media/memo_doc_text.1714ab2a.svg";